document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.pdp-hero-section');
  const thumbs = section.querySelectorAll('.pdp-hero-section__desktop-thumb');

  const onHashChange = () => {
    const hash =
      window.location.hash.substring(1) || thumbs[0]?.href.split('#')[1];

    thumbs.forEach((thumb) => {
      thumb.classList.remove('pdp-hero-section__desktop-thumb--active');

      if (thumb.href.includes(hash)) {
        thumb.classList.add('pdp-hero-section__desktop-thumb--active');
      }
    });
  };
  window.addEventListener('hashchange', onHashChange);

  const addToCartButtons = document.querySelectorAll(
    '.pdp-hero-section__add-to-cart'
  );
  const buyNowButtons = document.querySelectorAll('.pdp-hero-section__buy-now');

  const defaultAddToCartInner = addToCartButtons[0].innerHTML;
  const defaultInStockText =
    document.querySelector('.pdp-hero-section__stock-count')?.textContent || '';
  const defaultUnlimitedText =
    document.querySelector('.pdp-hero-section__stock-unlimited')?.textContent ||
    '';

  let actionTarget = '';

  // Diagonal angle for variant buttons
  const allVariantsButtons = document.querySelectorAll(
    '.pdp-option .variant-value'
  );
  allVariantsButtons.forEach((button) => {
    if (button.offsetHeight && button.offsetWidth) {
      button.style.setProperty(
        '--diagonal-angle',
        `${
          -Math.atan((button?.offsetHeight ?? 1) / (button?.offsetWidth ?? 1)) *
          (180 / Math.PI)
        }deg`
      );
    } else {
      button.style.setProperty('--diagonal-angle', '-45deg');
    }
  });

  const productData = JSON.parse(
    document.getElementById('product-data').textContent
  );
  let selectedOptions = [...productData.options.map(() => null)];
  let selectedVariant = productData.variants[0];

  const addToCartVariant = async (variant) => {
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: variant.id,
          quantity: 1,
        }),
      });

      console.log('added_to_cart');

      addToCartButtons.forEach((addToCartBtn) => {
        addToCartBtn.innerHTML = 'Added!';
        setTimeout(() => {
          addToCartBtn.innerHTML = defaultAddToCartInner;
          addToCartBtn.disabled = false;
        }, 1500);
      });

      // 👉 cart bubble update
      const bubbles = document.querySelectorAll('.cart-count-bubble');
      const itemsCount = parseInt(bubbles[0].textContent);
      bubbles.forEach((bubble) => {
        bubble.textContent = itemsCount + 1;
      });
    } catch (err) {
      console.error('Error adding to cart', err);
    }
  };

  const buyNowVariant = async (variant) => {
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: selectedVariant.id, quantity: 1 }),
      });
      console.log('added_to_cart');
      window.location.href = '/checkout';
    } catch (err) {
      console.error('Buy Now failed', err);
    }
  };

  allVariantsButtons.forEach((variant) => {
    variant.addEventListener('click', () => {
      const currentMode =
        variant.closest('.pdp-hero-section__mode-cart')?.dataset.mode || 'dom';
      if (currentMode === 'cart') {
        return;
      }

      const actions = document.getElementById('pdp-actions--dom');
      actions.classList.remove('is-hidden');

      const firstAvailableVariantOfCurrentOption = productData.variants.find(
        (v) => {
          return v.options.every((opt, idx) => {
            if (
              idx ===
              parseInt(variant.closest('.pdp-option').dataset.optionIndex)
            ) {
              return opt === variant.dataset.value;
            }
            return true;
          });
        }
      );

      if (actionTarget === 'add-to-cart') {
        addToCartVariant(firstAvailableVariantOfCurrentOption);
      } else if (actionTarget === 'buy-now') {
        buyNowVariant(firstAvailableVariantOfCurrentOption);
      }
    });
  });

  // Add to Cart
  addToCartButtons.forEach((addToCartBtn) => {
    addToCartBtn.addEventListener('click', async (e) => {
      const currentMode =
        addToCartBtn.closest('.pdp-hero-section__mode-cart')?.dataset.mode ||
        'dom';
      if (currentMode === 'dom') {
        const target = e.currentTarget.dataset.open;
        const actions = document.getElementById('pdp-actions--dom');
        actions.classList.add('is-hidden');
        actionTarget = target;
        return;
      }

      e.preventDefault();
      if (!selectedVariant) return alert('Please select options first');

      addToCartBtn.disabled = true;
      addToCartBtn.innerHTML = 'Adding...';

      addToCartVariant(selectedVariant);
    });
  });

  // Buy Now (redirect to checkout with variant)
  buyNowButtons.forEach((buyNowBtn) => {
    buyNowBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      if (!selectedVariant) return alert('Please select options first');

      buyNowVariant(selectedVariant);
    });
  });

  function updateOptionAvailability() {
    productData.options.forEach((optionName, optionIndex) => {
      const optionButtons = document.querySelectorAll(
        `.pdp-option[data-option-index="${optionIndex}"] .variant-value`
      );

      optionButtons.forEach((btn) => {
        const testOptions = [...selectedOptions];
        testOptions[optionIndex] = btn.dataset.value;

        const possibleVariant = productData.variants.find((v) =>
          v.options.every(
            (opt, idx) => !testOptions[idx] || testOptions[idx] === opt
          )
        );

        if (possibleVariant && possibleVariant.available) {
          btn.disabled = false;
        } else {
          btn.disabled = true;
          btn.classList.remove('variant-value--selected');
        }
      });
    });
  }

  function getInventoryByVariantId(variantId) {
    const variant = window.productData.variants.find((v) => v.id == variantId);

    if (variant?.available && (variant?.inventory_quantity ?? 0) <= 0) {
      return -1;
    }

    return variant?.inventory_quantity ?? 0;
  }

  function getVariantObjectById(variantId) {
    return window.productData.variants.find((v) => v.id == variantId);
  }

  function updateSelectedVariant() {
    selectedVariant = productData.variants.find((v) => {
      return v.options.every((opt, idx) => selectedOptions[idx] === opt);
    });

    // 👉 calculate inventory for currently selected variant

    const elementsWithInventory = document.querySelectorAll(
      '.pdp-hero-section__stock-count'
    );

    elementsWithInventory.forEach((element) => {
      const inventory_quantity = getInventoryByVariantId(selectedVariant.id);
      element.textContent =
        inventory_quantity === -1
          ? defaultUnlimitedText
          : `${inventory_quantity} ${defaultInStockText}`;
    });

    const allRegularPrices = document.querySelectorAll(
      '.price-block__item.price-block__item--regular'
    );
    const allCompareAtPrices = document.querySelectorAll(
      '.price-block__item.price-block__item--sale'
    );

    const selectedVariantObject = getVariantObjectById(selectedVariant.id);
    allRegularPrices.forEach((price) => {
      price.textContent = selectedVariantObject?.priceRegular
        ? selectedVariantObject.priceRegular
        : '';
    });

    allCompareAtPrices.forEach((price) => {
      price.textContent = selectedVariantObject?.compareAtPrice
        ? selectedVariantObject.compareAtPrice
        : '';
    });

    if (selectedVariant && selectedVariant.available) {
      addToCartButtons.forEach((addToCartBtn) => {
        addToCartBtn.disabled = false;
      });
      buyNowButtons.forEach((buyNowBtn) => {
        buyNowBtn.disabled = false;
      });
    } else {
      addToCartButtons.forEach((addToCartBtn) => {
        addToCartBtn.disabled = true;
      });
      buyNowButtons.forEach((buyNowBtn) => {
        buyNowBtn.disabled = true;
      });
    }

    updateOptionAvailability();
  }

  // Handle clicks on options
  document
    .querySelectorAll(
      '.pdp-hero-section__product-form-quick-add .variant-value'
    )
    .forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const optionIndex = parseInt(
          button.closest('.pdp-option').dataset.optionIndex
        );
        selectedOptions[optionIndex] = button.dataset.value;

        // UI active state
        button
          .closest('.pdp-values')
          .querySelectorAll('button')
          .forEach((b) => b.classList.remove('variant-value--selected'));
        button.classList.add('variant-value--selected');

        updateSelectedVariant();
      });
    });
  // Initialize current options
  const variant = productData.variants[0];
  selectedOptions = [...variant.options];

  document
    .querySelectorAll(
      '.pdp-hero-section__product-form-quick-add .pdp-values button'
    )
    .forEach((option) => {
      option.classList.remove('variant-value--selected');
      if (variant.options.includes(option.dataset.value)) {
        option.classList.add('variant-value--selected');
      }
    });

  updateSelectedVariant();

  onHashChange();

  const parentBlock = document.querySelector(
    '.pdp-hero-section__media-container'
  );
  const stickyBlock = document.querySelector(
    '.pdp-hero-section__mobile-product-info'
  );
  let lastStickyMode = stickyBlock?.dataset.mode || '';
  let stickyTicking = false;

  function updateStickyMode() {
    if (!parentBlock || !stickyBlock) return;
    const rect = parentBlock.getBoundingClientRect();

    const inStickyWindow = rect.top <= 50 && rect.bottom > window.innerHeight;
    const nextMode = inStickyWindow ? 'cart' : 'dom';

    if (nextMode !== lastStickyMode) {
      stickyBlock.dataset.mode = nextMode;
      lastStickyMode = nextMode;
    }
  }

  function onScrollSticky() {
    if (stickyTicking) return;
    stickyTicking = true;
    requestAnimationFrame(() => {
      updateStickyMode();
      stickyTicking = false;
    });
  }

  window.addEventListener('scroll', onScrollSticky, { passive: true });
  window.addEventListener('resize', onScrollSticky, { passive: true });
  updateStickyMode();

  const accordionItems = document.querySelectorAll('.pdp-accordion__item');
  accordionItems.forEach((item) => {
    const button = item.querySelector('button');

    button.addEventListener('click', () => {
      button.classList.toggle('is-open');
    });
  });
});
